import css from "styled-jsx/css";

export const componentStyles = css`
  .product-tags-component {
    height: 350px;
  }
`;
